import { connect } from 'react-redux';
import CiticRiskMonitoringDashboard from '../components/CiticRiskMonitoringDashboard';
import { queryCiticRiskMonitoring, citicRiskMonitoringSearchChangeInput } from '../fundRiskMonitoringActions';

const mapStateToProps = state => {
    return {
        citicRiskMonitoringList: state.fundRiskMonitoring.citicRiskMonitoringList,
        queryCiticRiskMonitoringStatus: state.fundRiskMonitoring.queryCiticRiskMonitoringStatus,
        citicRiskMonitoringSearchFields: state.fundRiskMonitoring.citicRiskMonitoringSearchFields,
    };
}

const mapDispatchToProps = dispatch => {
    return {
        queryCiticRiskMonitoring: (params) => dispatch(queryCiticRiskMonitoring(params)),
        citicRiskMonitoringSearchChangeInput: (input) => dispatch(citicRiskMonitoringSearchChangeInput(input)),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CiticRiskMonitoringDashboard);
